import * as THREE from 'three'
import React, { useMemo, useRef } from 'react'
import { useFrame, useLoader } from 'react-three-fiber'
import { TextureLoader } from 'three/build/three.module'
const image = './newspaper-texture.png'

const Cloud = ({ count }) => {
	const mesh = useRef()
	const dummy = useMemo(() => new THREE.Object3D(), [])
	const texture = useLoader(TextureLoader, image)

	const particle = useMemo(() => {
		const tmp = []

		for (let i = 0; i < count; i++) {
			const t = Math.random() * 100
			const factor = 20 + Math.random() * 100
			const speed = 0.001 + Math.random() / 1000
			const xFactor = -100 + Math.random() * 200
			const yFactor = -100 + Math.random() * 200
			const zFactor = -5 + Math.random() * 10
			tmp.push({ t, factor, speed, xFactor, yFactor, zFactor, mx: 0, my: 0 })
		}
		return tmp
	}, [count])

	useFrame(state => {
		particle.forEach((p, i) => {
			let { t, factor, speed, xFactor, yFactor, zFactor } = p

			t = p.t += speed / 5
			const a = Math.cos(t) + Math.sin(t * 1) / 10
			const b = Math.sin(t) + Math.cos(t * 2) / 10
			const s = Math.max(8, Math.cos(t) * 12)
			p.mx += -p.mx * 0.02
			p.my += -p.my + 0.02

			dummy.rotation.set(
				0, 0, Math.cos(t) * Math.PI
			)
			dummy.position.set(
				(p.mx / 5) * a + xFactor + Math.cos((t / 10) * factor) + (Math.sin(t * 1) * factor) / 5,
				(p.my / 5) * b + yFactor + Math.sin((t / 10) * factor) + (Math.cos(t * 2) * factor) / 5,
				(p.my / 10) * b + zFactor + Math.cos((t / 10) * factor) + (Math.sin(t * 3) * factor) / 100 - 40
			)
			dummy.scale.set(s, s, 0.5)
			dummy.updateMatrix()
			mesh.current.setMatrixAt(i, dummy.matrix)
		})
		mesh.current.instanceMatrix.needsUpdate = true
	})

	return (
		<>
			<instancedMesh ref={mesh} args={[null, null, count]} rotation={[Math.PI / 2, 0, 0]}>
				<sphereBufferGeometry attach="geometry" args={[1, 9, 9]} />
				<meshToonMaterial attach="material" color="#EFF" flatShading={true} map={texture} fog={false} />
			</instancedMesh>
		</>
	)
}

export default Cloud